import { useState, type ReactNode } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export function AttributeReviewSection({
  id,
  title,
  note,
  children,
}: {
  id: string;
  title: string;
  note?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(true);
  return (
    <>
      <div className="mt-6 mb-3">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls={id}
          className="inline-flex items-center gap-2 rounded-md text-sm font-semibold text-slate-700 hover:text-slate-950 dark:text-slate-300 dark:hover:text-slate-50 focus:outline-none focus:ring-1 focus:ring-indigo-500"
        >
          {open ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
          <span>{title}</span>
        </button>
        {note && (
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            {note}
          </p>
        )}
      </div>
      {open && <div id={id}>{children}</div>}
    </>
  );
}
